<!-- Feature 059 (FR-018): la campana solo existe con un rol de campana (crm-viewer solo no la ve). -->
@if (isVisible()) {
  <button
    #bellOrigin
    type="button"
    mat-icon-button
    class="relative"
    aria-label="Notificaciones"
    aria-haspopup="dialog"
    [attr.aria-expanded]="isOpen()"
    (click)="togglePanel()"
  >
    <mat-icon class="icon-size-6" [svgIcon]="'heroicons_outline:bell'"></mat-icon>

    <!-- El contador es el `bp-badge` del catálogo (070, T048), con su alto de `text-sm`: va en la
         esquina del botón (que no recorta, `overflow: visible`) para no tapar la campana. -->
    <span class="absolute top-0 right-0 flex items-center pointer-events-none">
      <!-- Contador desconocido: esqueleto. El span queda siempre en el DOM para que la directiva
           pueda retirar el esqueleto cuando llega la respuesta. -->
      <span
        [bp-skeleton]="isLoading()"
        skeletonWidth="2"
        skeletonHeight="2"
        skeletonType="circle"
      ></span>

      @if (!isLoading() && hasBadge()) {
        <span bp-badge="primary" class="tabular-nums">{{ badgeLabel() }}</span>
      }
    </span>
  </button>

  <ng-template #panelTemplate>
    <bp-notification-panel (closed)="closePanel()"></bp-notification-panel>
  </ng-template>
}
